module.exports = __webpack_public_path__ + "img/empty.481dc640.png";